import { render, staticRenderFns } from "./DashboardVentas.vue?vue&type=template&id=43085744&scoped=true&lang=pug"
import script from "./DashboardVentas.vue?vue&type=script&lang=js"
export * from "./DashboardVentas.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentas.vue?vue&type=style&index=0&id=43085744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43085744",
  null
  
)

export default component.exports